// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"37e458f4","237":"2f219105","350":"c7dafabc","525":"c6f90939","614":"154e9844","638":"a23bf633","646":"fc39180c","703":"be6bfd40","881":"5e82ae86"}[chunkId] + ".chunk.js";
};